var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"index-box container"},[_c('el-container',[_c('el-header',[_c('headers')],1),_c('el-main',[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }